import React from 'react';

const NotesAttachmentsModal = ({
  isVisible,
  notes,
  attachments,
  onNotesChange,
  onAttachmentsChange,
  onClose,
  playSound
}) => {
  if (!isVisible) return null;

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      onAttachmentsChange([...attachments, ...files]);
      playSound('camera-shutter', 'attachment-added');
    }
  };

  const removeAttachment = (idx) => {
    onAttachmentsChange(attachments.filter((_, i) => i !== idx));
  };

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl p-6 max-w-lg w-full mx-4 border border-solid border-gray-300 relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title */}
        <h2 className="text-[var(--pbfs-navy)] font-bold text-2xl mb-6 text-center">
          Add Notes & Attachments
        </h2>
        
        {/* Notes Text Area */}
        <textarea
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          placeholder="Add any additional notes here..."
          className="w-full h-32 bg-white text-[var(--pbfs-navy)] rounded-lg p-4 mb-4 border border-solid border-gray-300 focus:outline-none focus:border-[var(--pbfs-green)] resize-none placeholder-gray-400"
        />
        
        {/* File Attachment Section */}
        <div className="mb-6">
          <label className="flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-[var(--pbfs-navy)] border border-solid border-gray-300 hover:border-[var(--pbfs-green)] rounded-lg p-4 cursor-pointer transition-all duration-200">
            <span className="text-xl">📎</span>
            <span>Attach File</span>
            <input
              type="file"
              multiple
              accept="image/*,.pdf,.doc,.docx"
              className="hidden"
              onChange={handleFileChange}
            />
          </label>
          {attachments.length > 0 && (
            <div className="mt-3 text-gray-600 text-sm">
              {attachments.map((file, idx) => (
                <div key={idx} className="flex items-center justify-between bg-gray-100 rounded p-2 mb-1">
                  <span className="truncate flex-1">📎 {file.name}</span>
                  <button
                    onClick={() => removeAttachment(idx)}
                    className="text-red-500 hover:text-red-600 ml-2"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
        
        {/* Close Button */}
        <button
          onClick={onClose}
          className="w-full bg-[var(--pbfs-green)] hover:bg-opacity-90 text-white font-bold py-3 rounded-xl transition-all duration-300 transform hover:scale-105"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default NotesAttachmentsModal;
